import { gql } from '@apollo/client';

export const FETCH_PERSONAL_TIMELINE_V2 = gql`
	query crewMemberTimeline($filter: CrewMemberTimelineFilter!) {
		crewMemberTimeline(filter: $filter, pagination: { page: 0, size: 1 }) {
			results {
				id
				fullName
				driverCard
				activitiesV2 {
					fromTimestamp
					toTimestamp
					activity {
						__typename
						... on CrewMemberWorkAssignmentActivityItem {
							title
							status
							activityType
							rideId
							sequenceGroupId
							shiftId
							fromStation {
								code
								id
								timezone
								name
								city {
									id
									name
								}
							}
							toStation {
								code
								id
								timezone
								name
								city {
									id
									name
								}
							}
							firstWorkAssignmentId
							firstWorkAssignmentVersion
							note
							extraActivities {
								id
								version
								fromTimestamp
								toTimestamp
								activityType
								status
								fromStation {
									id
									code
									name
									timezone
									city {
										id
										name
									}
								}
								toStation {
									id
									code
									name
									timezone
									city {
										id
										name
									}
								}
								sequenceGroupId
							}
						}
						... on CrewMemberAbsenceActivityItem {
							id
							note
							reason {
								id
								name
							}
							availableForAssignments
						}
						... on CrewMemberBreakActivityItem {
							breakType
						}
					}
				}
				shifts {
					id
					fromTimestamp
					toTimestamp
					autoCloseTimestamp
				}
			}
			page {
				size
				page
			}
		}
	}
`;
